import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        /**
         * if getting a 401 unauthenticated
         * then retry 1 time to refresh token
         * if not working, the second time will
         * pass the error to the error handler
         */
        if (error.status === 401) {
          // refresh token by forwarding the user to login
        } else {
          return throwError(error);
        }
      })
    );
  }
}
